import { colors } from "./colors";
import { createTheme } from "@material-ui/core/styles"

const theme = createTheme({
    palette: {
        primary: {
            main: `${colors.mainBlue}`,
            light: `${colors.lightBlue}`,
            dark: `${colors.darkBlue}`
        }
    },
    typography: {
        body1: {
            fontSize: '1.2rem'
        }
    },
    colors
})

export { theme };